export const getShortName = (name) =>
  name.length > 2 ? name.substr(name.length - 2, 2) : name;
